
export const dictionary = {
    ru: {
        custom: {

        }
    },
    en: {
        custom: {

        }
    }
};



// WEBPACK FOOTER //
// ./src/validate/index.js